import React from 'react';
import axios from 'axios';

import Loading from '../Loading'

import styles from '../../styles/DynamicModal.module.css';

const AddNewCommentToCase = ({ caseId, access, onNewCommentSuccess }) => {
    const [isShowAddPanel, setIsShowAddPanel] = React.useState(false);
    const [comment, setComment] = React.useState('');
    const [mailing, setMailing] = React.useState('0');
    const [loading, setLoading] = React.useState(false);
    const [status, setStatus] = React.useState('');
    const [error, setError] = React.useState('');

    const attachNewFile = (e) => {
        e.preventDefault();

        setLoading(true);

        if (comment) {
            axios.post('/api/add-new-comment', {
                caseId,
                comment,
                mailing
            }).then(() => {
                setStatus('Комментарий успешно добавлен');
                onNewCommentSuccess();
                setTimeout(() => {
                    setStatus('');
                    setComment('');
                    setIsShowAddPanel(false);
                }, 2300);
                setLoading(false);
            }).catch(error => {
                setError(`Ошибка при добавлении нового комментария: ${error.response?.data.message || error.message}`);
                setLoading(false);
            });
        } else {
            setError('Вы не ввели обязательные поля');
            setLoading(false);
        }
        setTimeout(() => {
            setError('');
        }, 3000);
    }

    return (
        isShowAddPanel ? (
            <>
            {!status &&
                <div className={styles.outliningPanel}>
                    <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '10px'}}>
                        <h2 style={{margin: '0', width: '80%'}}>Добавьте новый общедоступный комментарий</h2>
                        <img src='/img/icons/close-x.svg' alt='X' style={{width: '20px', cursor: 'pointer'}} onClick={() => {setIsShowAddPanel(false)}} />
                    </div>
                    <a>Введите комментарий</a>
                    <input type='text' value={comment} onChange={(e) => setComment(e.target.value)} maxLength='150' placeholder='Комментарий' required />
                    {access && 
                    <div className={styles.lineCheckBox}>
                        <a>Отметьте, если хотите отправить уведомление арбитражному управляющему</a>
                        <input
                            type="checkbox"
                            checked={mailing == '1'}
                            onChange={(e) => {setMailing(e.target.checked ? '1' : '0'); console.log(mailing);}}
                        />
                    </div>}
                    {loading ? <Loading /> : <button type='submit' className='button maxWidth' style={{marginTop: '10px'}} onClick={(e) => {attachNewFile(e)}}>Добавить</button>}
                    {error && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{error}</a>}
                </div>
            }
            {status && <a className={styles.statusPanel}><img src='/img/icons/check-circle.svg' alt='Статус' />{status}</a>}
        </>
        ) : (
            <button type='button' className='button maxWidth' style={{marginTop: '10px'}} onClick={() => {setIsShowAddPanel(true)}}>Добавить новый комментарий</button>
        )
    )
}

export default AddNewCommentToCase;
